import React from 'react';
import { Heading, Paragraph, Text } from '@mlc/web-ui-toolkit';
import { InvestorMovement as InvestorMovementType } from '../../../../../../logic/domains/planProfile.domain';
import { InvestorMovementContent as content } from './StaticContent';
import { asNumber, asTodaysDate } from '../../../../../common/formatter';
import planProfileTestIds from '../../PlanProfile.elements';

interface Props {
	investorMovement: InvestorMovementType;
	asAtDate: string;
}

const InvestorMovement: React.FunctionComponent<Props> = props => {
	return (
		<React.Fragment>
			<Text
				data-id={planProfileTestIds.memberDemoMovementAsAtDate}
				el="h5"
				fontWeight="semibold"
				marginTop={6}
				marginBottom={4}
			>
				{content.heading}
				{asTodaysDate()}
			</Text>
			<Paragraph data-id={planProfileTestIds.memberDemoInvestorAsAtDate}>
				{content.startDate.replace(
					'date',
					props.investorMovement.financialYearStartDate
				)}
				<Text
					data-id={planProfileTestIds.memberDemoInvestorStartValue}
					fontWeight="semibold"
				>
					{asNumber(props.investorMovement.investorStart)}
				</Text>
			</Paragraph>
			<Paragraph>
				{content.exits}
				<Text
					data-id={planProfileTestIds.memberDemoInvestorExitValue}
					fontWeight="semibold"
				>
					{asNumber(props.investorMovement.investorExit)}
				</Text>
			</Paragraph>
			<Paragraph>
				{content.newInvestors}
				<Text
					data-id={planProfileTestIds.memberDemoInvestorNew}
					fontWeight="semibold"
				>
					{asNumber(props.investorMovement.investorNew)}
				</Text>
			</Paragraph>
			<Paragraph>
				{content.totalInvestors}
				<Text
					data-id={planProfileTestIds.memberDemoInvestorsTotal}
					fontWeight="semibold"
				>
					{asNumber(props.investorMovement.totalInvestors)}
				</Text>
			</Paragraph>
		</React.Fragment>
	);
};

export default InvestorMovement;
